import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxExpenseEdit = cashBoxRegister("CashBoxExpenseEdit")

export default CashBoxExpenseEdit
